import React, { useEffect, useMemo, useRef, useState } from "react";
import { FaCaretDown } from "react-icons/fa";

export function UserAttributeDropdown({
  value,
  options,
  getStyle,
  placeholder = "Select",
  onSelect,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, []);

  const handleSelect = (optionValue) => {
    const normalizedCurrent = String(value ?? "").toLowerCase();
    const normalizedNext = optionValue.toLowerCase();
    if (normalizedCurrent === normalizedNext) {
      setOpen(false);
      return;
    }
    onSelect?.(optionValue);
    setOpen(false);
  };

  const currentLabel = useMemo(() => {
    const normalizedValue = String(value ?? "").toLowerCase();
    const matchedOption = options.find(
      (option) => option.value.toLowerCase() === normalizedValue
    );
    return matchedOption?.label ?? placeholder;
  }, [options, value, placeholder]);

  return (
    <div
      ref={containerRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      <div
        className="pill-status"
        style={{
          ...(typeof getStyle === "function" ? getStyle(value) : {}),
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.7 : 1,
        }}
        onClick={(event) => {
          event.stopPropagation();
          if (!disabled) {
            setOpen((prev) => !prev);
          }
        }}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <span>{currentLabel}</span>
        <FaCaretDown style={{ fontSize: "0.8rem" }} />
      </div>

      {open && (
        <div role="menu" className="option-menu">
          {options.map((option) => {
            const optionValue = option.value;
            const isSelected =
              String(value ?? "").toLowerCase() === optionValue.toLowerCase();
            return (
              <div
                key={option.value}
                role="menuitem"
                className="menu-item"
                style={{
                  backgroundColor: isSelected ? "#f5f5f5" : "#ffffff",
                  fontWeight: isSelected ? 600 : 400,
                }}
                onMouseDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                  event.stopPropagation();
                  if (disabled) {
                    return;
                  }
                  handleSelect(optionValue);
                }}
              >
                {option.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
